import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_PROGRAMA_CEAE_NUTRICIONISTA = gql`
  mutation saveVisitaCeaeNutricionista($input: AddVisitaCeaeNutricionistaInput!) {
    saveVisitaCeaeNutricionista(input: $input) {
      idVisita
      idVisitaCeae
    }
  }
`;

export default SAVE_PROGRAMA_CEAE_NUTRICIONISTA;

export const adaptAddVisitaCEAENutricionistaInput = (data) => ({
  idVisitaCeae: data?.idVisitaCeae,
  justificacionModificacion: data?.justificacionModificacion,
  indicacionComentario: data?.indicacionComentario,
  caloriasTotales: data?.caloriasTotales,
  caloriasSO: data?.caloriasSO,
  porcentajeSO: data?.porcentajeSO,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});